import { Field } from "formik"
import React from "react"
import cx from "classnames"
import { FormContext } from "../Form"

const Textarea = ({ label, name, validate, required, placeholder }) => {
  //const [value, meta, helpers] = useField(name)

  return <FormContext.Consumer>
    {({ negative, big }) => {
      return <Field name={name} validate={(value) => {
        if (required && !value) {
          return required
        }
        if (validate && typeof validate === 'function') {
          return validate(value)
        }
      }}>
        {({ field, meta }) => {
          const error = meta.touched && meta.error
          return <div className="w-full">
            {label && <label className={cx("block mb-0.5 font-medium text-small", {
              "text-midnight-10": !negative,
              "text-midnight-60": negative
            })}>{label}{required && "*"}</label>}
            <textarea
              {...field}
              placeholder={placeholder}
              className={cx("block w-full rounded border-2 bg-transparent ", {
                "border-mid-night-50 focus:border-blue-10 focus:shadow-input-focus placeholder:text-midnight-40 outline-none": !negative,
                "border-midnight-50 focus:border-white focus:shadow-input-focus-negative placeholder:text-midnight-30 outline-none": negative,
                "px-2 py-1.5": !big,
                "px-2 py-3": big,
                "!border-[#EA344A]": error
              })}
            />
            {error && <div className="text-[#EA344A] mt-0.5 text-small">{error}</div>}
          </div>
        }}

      </Field>
    }}
  </FormContext.Consumer>
}

export default Textarea